// Historic ticket search filter, moved unchanged from TicketsHistoricPage.tsx.
// Kept free of React, DevExtreme and path aliases so Node can load it in the checks.
// The output must stay exactly as before, including the trailing 'or' in each word
// group (DevExtreme ignores it when it serializes the filter).

// StatoTicket.COMPLETATO and StatoTicket.ELIMINATO (TicketEditor.enums.tsx).
const STATO_COMPLETATO = 2
const STATO_ELIMINATO = 3

/** Builds the note-collection predicate value; the page passes `(expr) => new EdmLiteral(expr)`. */
export type NoteLiteralFactory = (expression: string) => unknown

export const createHistoricBaseFilter = (): unknown[] => [
  [['stato/id', STATO_COMPLETATO], 'or', ['stato/id', STATO_ELIMINATO]],
  'and',
  ['apertura', '>=', new Date(2016, 1, 1, 0, 0, 0)],
]

/** Trims input; returns null when no search is active. */
export const normalizeHistoricSearch = (value: unknown): string | null => {
  const text = typeof value === 'string' ? value.trim() : ''
  return text.length > 0 ? text : null
}

export const filterSplitter = (input: string): string[] => {
  const regex = /"([^"]+)"|\S+/g
  const result: string[] = []
  let match: RegExpExecArray | null

  while ((match = regex.exec(input)) !== null) {
    if (match[1]) {
      // If it's a quoted word, use group 1
      result.push(match[1])
    } else {
      // Otherwise, use the full match
      result.push(match[0])
    }
  }

  return result
}

/**
 * Returns the historic scope, combined with the search words when a search is active.
 * Each word must match the solution, the description or a note (OR); all words must match (AND).
 */
export const buildHistoricFilter = (searchText: string | null, noteLiteral: NoteLiteralFactory): unknown[] => {
  const initialFilterValue = createHistoricBaseFilter()
  if (!searchText) return initialFilterValue

  const filter: unknown[] = []
  const splittedWords = filterSplitter(searchText)
  for (const word of splittedWords) {
    filter.push(
      [
        ['soluzione', 'contains', word],
        'or',
        ['descrizione', 'contains', word],
        'or',
        [
          // Escape single quotes by doubling them
          noteLiteral(
            `note_ticket/any(nota: contains(tolower(nota/testo), '${word.toLowerCase().replace(/'/g, "''")}'))`,
          ),
          '=',
          true,
        ],
        'or',
      ],
      'and',
    )
  }
  filter.pop()
  return [[...initialFilterValue], 'and', [filter]]
}
